// Column Block JS
document.addEventListener('DOMContentLoaded', () => {
  // This file is kept for consistency with the theme structure
  // All functionality is handled inline in the block template
}); 